export const define = (storeName, ...mixins) => {
    var state = {},
        actions = {},
        mutations = {};
    for (var mixin of mixins) {
        var module = mixin(storeName);
        state = Object.assign(state, module.state);
        actions = Object.assign(actions, module.actions);
        mutations = Object.assign(mutations, module.mutations);
    }
    return {
        namespaced: true,
        state,
        actions,
        mutations
    };
};
